enum PaymentStatusEnum {
  NotPaid = 'not-paid',
  Paid = 'paid',
  Pending = 'pending',
  Sent = 'sent',
  Unknown = 'unknown',
}

export default PaymentStatusEnum;
